import React from 'react'
import { Button } from 'reactstrap'
import clsx from 'clsx'

const ButtonPrev = ({ onClick, className }) => {
  return <Button className={clsx('btn-prev btn-arrow-prev', className)} onClick={onClick}>Back</Button>
}

export default ButtonPrev
